export const isExternalLink = (link: string): boolean => {
  // A valid external link should start with http(s):// or www.
  const externalUrl = /^(https?:\/\/|http:\/\/|www\.)/i
  const mailTo = /^mailto:/

  return externalUrl.test(link) || mailTo.test(link)
}

export const isInPageLink = (link: string): boolean => {
  return link.startsWith('#')
}

export const prependInternalLink = (link: string) => {
  // Ensure all internal links have a full path and are not relative to current page
  return link.startsWith('/') ? link : `/${link}`
}

export const safeLink = (link: string): string => {
  return isExternalLink(link) ? link : prependInternalLink(link)
}

export const trimSlashes = (link: string): string => {
  return link.replace(/^\/+|\/+$/g, '')
}

export const isDOM = (): boolean => {
  return typeof window !== `undefined`
}

/**
 * Extracts the filename with extension from a full image URL path.
 *
 * @example
 * convertUrlToImageFileIdentifier('https://example.com/path/image-123.png')
 * // Returns: 'image-123.png'
 *
 * @param url - The full URL of the image
 * @returns The image filename with extension
 */
export function convertUrlToImageFileIdentifier(url: string): string {
  return url.split('/').pop() || ''
}
